import { render, staticRenderFns } from "./ModalForgotPassword.vue?vue&type=template&id=6c7e6068&lang=pug&"
import script from "./ModalForgotPassword.vue?vue&type=script&lang=js&"
export * from "./ModalForgotPassword.vue?vue&type=script&lang=js&"
import style0 from "./ModalForgotPassword.vue?vue&type=style&index=0&id=6c7e6068&prod&lang=sass&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports